export const USER_ROLES = ['super_admin', 'academy_admin', 'teacher', 'parent'] as const

export type UserRole = (typeof USER_ROLES)[number]

export const ACADEMY_STATUSES = ['trial', 'active', 'suspended', 'cancelled'] as const
export type AcademyStatus = (typeof ACADEMY_STATUSES)[number]

export const PLAN_PRICING_MODELS = ['pay_as_you_go', 'monthly', 'annual'] as const
export type PlanPricingModel = (typeof PLAN_PRICING_MODELS)[number]

export const PLAN_STATUSES = ['published', 'unpublished', 'deprecated'] as const
export type PlanStatus = (typeof PLAN_STATUSES)[number]

export const ATTENDANCE_STATUSES = ['present', 'absent', 'late', 'excused'] as const
export type AttendanceStatus = (typeof ATTENDANCE_STATUSES)[number]
